import { Directive, ElementRef, HostListener, Input, Renderer } from '@angular/core';
import { SuitabilityScoreBehaviorService } from '../state-manager/behavior-subjects/suitability-behavior.service';

@Directive({
  selector: 'input[suitabilityControl]'
})
export class SuitabilityControlDirective {

  @Input() suitabilityValue: number;
  constructor(private _el: ElementRef, protected suitabilityService: SuitabilityScoreBehaviorService) { }

  @HostListener('click', ['$event']) onInputChange(event) {
    const name = this._el.nativeElement.dataset.question;
    this.suitabilityService.changePontuation(name, this.suitabilityValue);
    event.stopPropagation();
  }

}
